import React from 'react';
import { Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

interface StartEndDatePickerProp {
    disabled?: boolean,
    startDateValue: Dayjs | null,
    endDateValue: Dayjs | null,
    dateRequired?: boolean,
    onStartDateChange: React.Dispatch<React.SetStateAction<Dayjs | null>>,
    onEndDateChange: React.Dispatch<React.SetStateAction<Dayjs | null>>,
    startDateValid: boolean,
    endDateValid: boolean,
    endLabel?: string
}

const StartEndDatePicker: React.FC<StartEndDatePickerProp> = ({
    disabled = false,
    startDateValue,
    endDateValue,
    startDateValid,
    endDateValid,
    onStartDateChange,
    onEndDateChange,
    dateRequired = false,
    endLabel = 'End Date'
}) => {
    return (
        <>
            <Grid item xs={6} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        disabled={disabled}
                        value={startDateValue}
                        onChange={onStartDateChange}
                        slotProps={{
                            textField: {
                                required: dateRequired,
                                error: !startDateValid,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f8f9fb', padding: '4px 2px' } }
                            }
                        }}
                        onError={(err) => {
                            console.log(err);
                        }}
                        label="Start Date"
                        sx={{ width: '100%' }} />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={endDateValue}
                        onChange={onEndDateChange}
                        disabled={disabled}
                        minDate={startDateValue || dayjs()}
                        slotProps={{
                            textField: {
                                required: dateRequired,
                                error: !endDateValid,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f8f9fb', padding: '4px 2px' } }
                            }
                        }}
                        label={endLabel}
                        sx={{ width: '100%' }} />
                </LocalizationProvider>
            </Grid>
        </>
    )
}

export default StartEndDatePicker;